import { render, staticRenderFns } from "./KBCard.vue?vue&type=template&id=71370d9f&scoped=true&"
import script from "./KBCard.vue?vue&type=script&lang=js&"
export * from "./KBCard.vue?vue&type=script&lang=js&"
import style0 from "./KBCard.vue?vue&type=style&index=0&id=71370d9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71370d9f",
  null
  
)

export default component.exports